module.exports = __webpack_public_path__ + "media/images/sample/product-sample-52d17fc88cd364e4d02d776cd53fc536.png";